import BorrowModal from 'src/components/Modals/CollateralModal/BorrowModal';
import DepositModal from 'src/components/Modals/CollateralModal/DepositModal';
import RepayModal from 'src/components/Modals/CollateralModal/RepayModal';
import TransferModal from 'src/components/Modals/CollateralModal/TransferModal';
import WithdrawModal from 'src/components/Modals/CollateralModal/WithdrawModal';
import DepositFromOtherSourcesModal from 'src/components/Modals/DepositFromOtherSourcesModal';
import useModal from 'src/components/Modals/hooks/useModal';

export default function CollateralModals() {
	const { currentModal } = useModal();

	return (
		<>
			{currentModal?.type === 'deposit' && (
				<DepositModal {...currentModal.props} />
			)}
			{currentModal?.type === 'deposit_from_other_sources' && (
				<DepositFromOtherSourcesModal {...currentModal.props} />
			)}
			{currentModal?.type === 'withdraw' && (
				<WithdrawModal {...currentModal.props} />
			)}
			{currentModal?.type === 'borrow' && (
				<BorrowModal {...currentModal.props} />
			)}
			{currentModal?.type === 'repay' && <RepayModal {...currentModal.props} />}
			{currentModal?.type === 'transfer' && (
				<TransferModal {...currentModal.props} />
			)}
		</>
	);
}
